import axios from "axios";
import { serverApi } from "../../../config/Keys";
import { CLEAR_ERRORS, CLEAR_LOADER } from "../../types";
import { setErrors } from "../errorActions";
import Alert from "react-s-alert";

export const pos_configuration_add =
  (token, formData, onSuccess) => async (dispatch) => {
    console.log(token, formData);
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.post(`${serverApi}/admin/pos`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        Alert.success(`<h4> Updated succesfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      Alert.error(`<h4>${err.response.data.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const pos_mark_for_deletion = async (_id, token, onsuccess, deletionStatus,otp) => {
  console.log(token,"token");
   
    try {
      let del_req = await axios.patch(
        `${serverApi}/admin/pos/${_id}?MARK_FOR_DELETE=${deletionStatus}`, {
          "OTP":otp
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (del_req.status === 200) {
        onsuccess();
        Alert.success(`<h4> marked for deletion with 90 days of residence period</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } catch (err) {
      console.log(err)
    }
  };

  export const pos_send_otp__for_deletion = async (_id, token, onsuccess, deletionStatus) => {
   
    try {
      let del_req = await axios.patch(
        `${serverApi}/admin/pos/${_id}?SEND_OTP_FOR_DELETE=${deletionStatus}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (del_req.status === 200) {
        onsuccess();
        Alert.success(`<h4> email sent successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } catch (err) {
      Alert.error(`<h4>${err}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

export const pos_configuration_test_connection  = async (token, formData, onSuccess) => {
    console.log("apicalled")
    try {
  
      let response = await axios.post(
        `${serverApi}/pos/api/PET_POOJA/testConnection`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success == 1) {
        Alert.success(`<h4> Updated succesfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
        onSuccess(response.data);
      }
    } catch (err) {
      Alert.error(`<h4>${err.response.data.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
